import { render, staticRenderFns } from "./ParentFolderPermissions.vue?vue&type=template&id=734e6c42&scoped=true&"
import script from "./ParentFolderPermissions.vue?vue&type=script&lang=js&"
export * from "./ParentFolderPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ParentFolderPermissions.vue?vue&type=style&index=0&id=734e6c42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e6c42",
  null
  
)

export default component.exports